// src/pages/exercise/components/Scene/Lighting.jsx

/*
  CONTEXT: Lighting configuration for the Exercise Scene
  GOAL: Centralize light sources and environment map
*/
import { Environment } from '@react-three/drei';

function Lighting() {
  return (
    <>
      <ambientLight intensity={1} />
      <directionalLight position={[-0.5, -1, 0]} intensity={1} />
      <Environment preset="apartment" environmentIntensity={0.7} />
    </>
  );
}

export default Lighting;
